module.exports = __webpack_public_path__ + "static/Gartnerhypecycle-3cc3e9125ac4f1af9e7afb36328ec97e.png";